import React, { useEffect, useState } from "react";
import { Col, Row } from '@themesberg/react-bootstrap';
import { faFileAlt, faSyncAlt, faCheckCircle } from "@fortawesome/free-solid-svg-icons";
import { CounterWidget } from "../../components/Widgets";
import { AllClaims } from "../../components/client/AllClaims";
import API from "../../utils/api";
import { useTranslation } from "react-i18next";
import { faEuroSign } from "@fortawesome/free-solid-svg-icons";
export default () => {
  const { t, i18n } = useTranslation();
  const [stats, setStats] = useState([
    { title: t("overviewTotalClaims"), value: 0, icon: faFileAlt, color: "primary" },
    { title: t("overviewInProgress"), value: 0, icon: faSyncAlt, color: "warning" },
    { title: t("overviewClaimsClosed"), value: 0, icon: faCheckCircle, color: "success" },
    { title: t("overviewTotalAmount"), value: 0, icon: faEuroSign, color: "info" }
  ]);

  useEffect(() => {
    const fetchClaims = async () => {
      try {
        const response = await API.get("/claims/own");
        const { stats } = response.data;  // 👈 use backend stats directly

        setStats([
          { title: t("overviewTotalClaims"), value: stats.total, icon: faFileAlt, color: "primary" },
          { title: t("overviewInProgress"), value: stats.inProcess, icon: faSyncAlt, color: "warning" },
          { title: t("overviewClaimsClosed"), value: stats.closed, icon: faCheckCircle, color: "success" },
          { title: t("overviewTotalAmount"), value: stats?.totalAmount, icon: faEuroSign, color: "info" }
        ]);
      } catch (error) {
        console.error("Error fetching claims:", error);
      }
    };

    fetchClaims();
  }, [i18n.language]);

  return (
    <>
      <Row className="justify-content-md-center">
        {stats.map((stat, index) => (
          <Col key={index} xs={12} sm={3} xl={3} className="mb-4">
            <CounterWidget
              category={stat.title}
              title={(stat.value ?? 0).toLocaleString()}
              period=""
              percentage=""
              icon={stat.icon}
              iconColor={`shape-${stat.color}`}
            />
          </Col>
        ))}
      </Row>

      <Row>
        <Col xs={12} className="mb-4">
          <AllClaims />
        </Col>
      </Row>
    </>
  );
};
